import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';

import { Icon } from 'sheets';
import { ResponsiveImage } from 'sheets';
import PlayOnScrollVideo from 'components/PlayOnScrollVideo/PlayOnScrollVideo';

import styles from './SplitImage.css';

const cx = classNames.bind(styles);

const SplitImage = (props) => {
  const imageContainerClass = cx(`split-image-container`, {
    'image-left': props.imagePosition === `left`,
    'image-right': props.imagePosition === `right`,
  });

  const videoConfig = {
    autoPlay: false,
    fallback: props.content.fallback,
    loop: true,
    path: props.content.video,
    poster: props.content.fallback,
    posterWidth: 600,
  };

  const renderMedia = () => {
    if (props.imageConfig) {
      return (
        <ResponsiveImage
          config={props.imageConfig}
          description={props.content.imageDescription}
        />
      );
    }

    return (
      <PlayOnScrollVideo
        offset={1000}
        videoClass={styles[`video`]}
        videoConfig={videoConfig}
      />
    );
  };

  const renderCallout = () => {
    if (props.callout) {
      return (
        <div className={styles[`callout`]}>
          <Icon
            className={styles[`callout-icon`]}
            name="line-wiggly"
          />
          <p className={styles[`callout-body`]}>
            {props.callout}
          </p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className={styles[`split-pane-container`]}>
      <div className={styles[`heading-small`]}>
        <h2 className={styles[`heading`]}>{props.content.heading}</h2>
      </div>
      <div className={imageContainerClass}>
        {renderMedia()}
      </div>
      <div className={styles[`content-container`]}>
        <div className={styles[`content-inner`]}>
          <div className={styles[`content`]}>
            <div className={styles[`heading-large`]}>
              <h2 className={styles[`heading`]}>{props.content.heading}</h2>
            </div>
            <p className={styles[`body`]}>{props.content.body}</p>
            {renderCallout()}
          </div>
        </div>
      </div>
    </div>
  );
};

SplitImage.propTypes = {
  callout: PropTypes.string,
  content: PropTypes.shape({
    body: PropTypes.string.isRequired,
    callout: PropTypes.string,
    heading: PropTypes.string.isRequired,
    imageDescription: PropTypes.string.isRequired,
    video: PropTypes.array,
    fallback: PropTypes.string,
  }),
  imageConfig: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  imagePosition: PropTypes.string.isRequired,
};

export default SplitImage;
